var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatiment5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "batiment_5",
    "data-name": "batiment 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2324 2157.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3b3b3f;}.cls-2,.cls-3{fill:#262628;}.cls-11,.cls-3,.cls-8{opacity:0.35;}.cls-4{fill:#d5d1db;stroke-width:7px;}.cls-13,.cls-4{stroke:#4c4b54;stroke-miterlimit:10;}.cls-5{fill:#bfbfbf;}.cls-6{fill:#6b6b6b;}.cls-7,.cls-8{fill:#9b9b9b;}.cls-9{fill:#08a7d7;}.cls-10,.cls-11{fill:#1283b5;}.cls-12{fill:#4c4b54;}.cls-13{fill:none;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "batiment 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1639.5 902 2157.5 2242 1382.5 2242 522.5 1353 0.5 0 786.5 0 1639.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "902 2157.5 0 1642.5 0 786.5 902 1293.5 902 2157.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2242 522.5 902 1293.5 902 2157.5 2242 1382.5 2242 522.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1121.5 2026 1121 1752.5 1351 1623.5 1346.5 1897 1121.5 2026"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1424.5 1772 1424 1498.5 1654 1369.5 1649.5 1643 1424.5 1772"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1798.5 1557 1798 1283.5 2028 1154.5 2023.5 1428 1798.5 1557"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "825.5 2026 826 1752.5 596 1623.5 600.5 1897 825.5 2026"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "531.21 1944.56 453 1990.5 377 1944.5 377 1513.5 454 1472.5 898 1729.5 2242 960.46 2324 1002.5 2324 1423.5 2242 1464.5 2171.68 1423.79 2172 1163.5 902 1900.5 531 1687.5 531.21 1944.56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "453 1990.5 453 1642.5 531 1687.5 531 1944.5 453 1990.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2172 1163.5 2243.26 1122.19 2242 1464.5 2172 1423.5 2172 1163.5"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "377 1944.5 453 1990.5 453 1642.5 902 1900.5 902 1816.5 377 1513.5 377 1944.5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2324 1002.5 902 1816.5 902 1900.5 2243 1122.5 2242 1464.5 2324 1423.5 2324 1002.5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "898 1729.5 824.84 1771.97 377 1513.5 453 1475.5 898 1729.5"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "0 960.46 0.5 787 1350.5 0 2241.5 523 2243.26 695.05 902 1472 0 960.46"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "902 1472.5 0 960.5 0 786.5 902 1293.5 902 1472.5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2243 695.5 2242 522.5 902 1293.5 902 1472.5 2243 695.5"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1227.16 1965.42 1227 1701.5 1244 1690.5 1244 1955.77 1227.16 1965.42"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1213,
    y1: 1824.5,
    x2: 1213,
    y2: 1882.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1255,
    y1: 1798.5,
    x2: 1255,
    y2: 1856.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatiment5);
export default __webpack_public_path__ + "static/media/batiment_5.94a7341631b744c62525ae1fb5a7867e.svg";
export { ForwardRef as ReactComponent };